import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CapacitacionComponent } from './capacitacion.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [  {
  path: '', 
  // canActivate: [AuthGuard],
  // canActivateChild: [AuthGuard],
  component: CapacitacionComponent,
  children: [
    { path: 'dashboard', component: DashboardComponent, data: { titulo: 'Dashboard' } },
    { path: '**', component: DashboardComponent, data: { titulo: 'Dashboard' } },
    { path: '', component: DashboardComponent, data: { titulo: 'Dashboard' } },

    // { path: '**', redirectTo: '/dashboard', pathMatch: 'full'},
    // { path: 'onboarding/paciente', component: PacienteComponent, data: { titulo: 'Onboardin Paciente'}}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CapacitacionRoutingModule { }
